import { render, staticRenderFns } from "./cam.vue?vue&type=template&id=a6a5fcb4&scoped=true"
import script from "./cam.vue?vue&type=script&lang=js"
export * from "./cam.vue?vue&type=script&lang=js"
import style0 from "./cam.vue?vue&type=style&index=0&id=a6a5fcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a5fcb4",
  null
  
)

export default component.exports